import React from 'react';
import {
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Dropdown
} from 'reactstrap';

class HeaderDropdown extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            dropdownOpen: false
        };
        this.toggle = this.toggle.bind(this);
    }

    toggle() {
        this.setState({
            dropdownOpen: !this.state.dropdownOpen
        });
    }


    dropAccnt() {
        return (
            <Dropdown nav isOpen={this.state.dropdownOpen} toggle={this.toggle}>
                <DropdownToggle nav>
                    <div className="header-dropdown img-avatar">
                        <i className="fa fa-user" ></i>
                    </div>
                </DropdownToggle>
                <DropdownMenu right>
                    <DropdownItem><i className="fa fa-lock"></i> Logout</DropdownItem>
                </DropdownMenu>
            </Dropdown>
        );
    }

    render() {
        return (
            this.dropAccnt()
        );
    }
}

export default HeaderDropdown;


// WEBPACK FOOTER //
// ./src/components/Header/HeaderDropdown.js